type TRoomType = 'NORMAL'

export const DomesticCouponApplicationType = {
  // 일반 쿠폰
  MAIN: 'MAIN',
  // 더하기쿠폰 1
  ADDITIONAL_ONE: 'ADDITIONAL_ONE',
  // 더하기쿠폰 2
  ADDITIONAL_TWO: 'ADDITIONAL_TWO',
} as const
export type TDomesticCouponApplicationType =
  (typeof DomesticCouponApplicationType)[keyof typeof DomesticCouponApplicationType]

export type TDomesticCouponRequestData = {
  // path
  memberNo: number
  placeId: number
  // query params
  stayType: string
  roomType: TRoomType
  originalRoomPrice: number
  roomPrice: number
  roomTypeId?: number
  checkinDateTime: string
  checkoutDateTime: string
  applicationType: TDomesticCouponApplicationType
  ratePlanId: number
}

// https://yanolja.atlassian.net/wiki/spaces/platformdiv/pages/89252371/Models#id-%EC%BF%A0%ED%8F%B0Models-CouponProgressDto
type TDomesticCouponProgress = {
  id: string
} & TMetaCouponProgress

type TMetaCouponProgress = {
  limitOffer?: number
  limitUse?: number
  offered?: number
  used?: number
}

type TDomesticCouponDatePeriod = {
  startAt: string
  endAt: string
}

// https://yanolja.atlassian.net/wiki/spaces/platformdiv/pages/89252371/Models#id-%EC%BF%A0%ED%8F%B0Models-UserCouponDto
type TDomesticCouponDto = {
  id: number | null
  metaCouponId: number
  couponName: string
  couponType: string
  week: string[]
  schema: {
    yanolja: string
    web: string
  }
  stayTypes: string[]
  roomTypes: TRoomType[]
  usableDistricts?: string[]
  minActualPayment: number
  applicableMinPrice: number
  maxDiscountPrice?: number
  applicableMaxPrice?: number
  discountType: string
  amount: number
  placeTypes: string[]
  placeClassification: string
  useInAdvance: number
  createdAt: string
  usablePeriod: TDomesticCouponDatePeriod
  usedAt?: string
  checkinPeriod?: TDomesticCouponDatePeriod
  status: string
  offeredPlaceNo?: number
  usedPlaceNo?: number
  usedPrice?: number
  category: string
  denyListGroupId?: number
  applicationType: TDomesticCouponApplicationType
  allowAdditional: boolean
}

export type TDomesticCoupon = {
  unavailableReasons: string[]
  progress?: TDomesticCouponProgress
  calculatedPrice: number
} & TDomesticCouponDto

export type TDomesticCouponResponseData = TDomesticCoupon[]

export type TDomesticCouponDownloadRequestData = {
  memberNo: number
  placeId: number
  metaCouponId: number
}

export type TDomesticCouponDownloadResponseData = number[]

export type TDomesticCouponByCouponIdRequestData = {
  memberNo: number
  couponId: number
}

export type TDomesticCouponByCouponIdResponseData = TDomesticCouponDto

export type TDomesticCouponsOfPropertyRequestData = {
  placeId: number
  checkInDate: string
}

type StayTypeConfigs = {
  stayType: string
  minActualPayment: number
  applicableMinPrice: number
  maxDiscount: string
  applicableMaxPrice: string
}

type Week = {
  possibleWeek: string
  impossibleWeek: string
}

export type TDomesticCouponsOfPropertyListItem = {
  couponIdx: number
  couponType: number
  price: number
  priceType: string
  maxPrice?: string
  couponName?: string
  minPrice?: number
  applicableMinPrice?: number
  product?: string
  roomType?: TRoomType
  usableRoomType: string
  notice?: string
  supplyStatus?: string
  checkin_started_at: string
  checkin_finished_at: string
  useInAdvance: number
  provideCondition: string
  useType: number
  stayTypeConfigs?: StayTypeConfigs[]
  week: Week
}

export type TDomesticCouponsOfPropertyResponseData = {
  totalCnt?: number
  maxDcPriceType?: string
  maxDcPrice?: number
  list?: TDomesticCouponsOfPropertyListItem[]
}

export type TPropertyCouponCheckProgressRentType = 'REST' | 'SLEEP' | 'DAYS' | 'ALL_DAY'

export type TDomesticCouponCheckProgressPayload = {
  metaCouponId: number
  requests: {
    placeId: number
    rentType: TPropertyCouponCheckProgressRentType
    requestCount: number
    checkInDate: string
  }[]
}

export type TDomesticCouponCheckProgressOfPropertyRequestData = {
  checkinDate: string
  placeNos: number[]
  channelName?: string
}

export type TDomesticCouponCheckProgressOfPropertyMetaProgress = {
  SLEEP: TMetaCouponProgress
  REST: TMetaCouponProgress
  DAYS: TMetaCouponProgress
}

export type TDomesticCouponCheckProgressOfPropertyMeta = {
  id: number
  progress: TDomesticCouponCheckProgressOfPropertyMetaProgress
}

export type TDomesticCouponCheckProgressOfPropertyResponseData = {
  placeNo: number
  metas: TDomesticCouponCheckProgressOfPropertyMeta[]
}

export type TDomesticCouponCheckProgressRequestData = {
  // path
  memberNo: number
  // body
  checkProgressPayload: TDomesticCouponCheckProgressPayload[]
}

export type TDomesticCouponCheckProgressResponseData = {
  metaCouponId: number
  couponType: string
  placeIds: number[]
  title: string
  usable: boolean
}[]
